__turbopack_context__.v({
  "seasonDropdown": "SeasonsDropdown-module-scss-module__SCPLLG__seasonDropdown",
});
